import DeleteModal from '@/components/Modals/DeleteModal';
import { useAnalytics } from '@/services/analytics';
import { GET_TRANSLATION_GROUPS_KEY, useDeleteTranslation } from '@/state/translations';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil';
import { translationToDelete } from '../state';

export const DeleteTranslationModal = () => {
    const mixpanel = useAnalytics();
    const [itemToDelete, setItemToDelete] = useRecoilState(translationToDelete);
    const { mutateAsync: deleteItem, isLoading: isDeleting } = useDeleteTranslation();
    const queryClient = useQueryClient();
    const videoName = itemToDelete && itemToDelete?.name ? itemToDelete.name : 'this video';

    const onItemDelete = async () => {
        if (itemToDelete) {
            mixpanel?.track('translate-delete', {
                event: 'click',
                from: 'translate-page',
                id: itemToDelete.id,
                language: itemToDelete.language,
            });

            await deleteItem(itemToDelete.id);
            setItemToDelete(null);
            await queryClient.invalidateQueries(GET_TRANSLATION_GROUPS_KEY);
        }
    };

    return (
        <DeleteModal
            itemType="video"
            mode="square"
            open={!!itemToDelete}
            isLoading={isDeleting}
            onDelete={onItemDelete}
            onClose={() => setItemToDelete(null)}
            poster={itemToDelete?.thumbnail_url ?? ''}
            text={{
                title: 'Confirm delete',
                content: `Are you sure you want to delete ${videoName} from your gallery?`,
                cta: 'Delete video',
            }}
        />
    );
};
